import { setConfig } from '@sdk/config/appConfig';
import type { Config } from '@sdk/config/appConfig';

import angularConfig from '@angular/config';

const getConfig = (config = angularConfig): Config => {
  // @NOTE: This facade is need as long as we base on old config inside angular.
  // With time we will hopefully end up having only 1 config.
  return setConfig({
    AMAZON_S3_BASE_URL: config.AMAZON_S3_BASE_URL,
    ANALYTICS_URL: config.ANALYTICS_END_POINT,
    APP_URL: config.SLING_APP_URL,
    APPLE_STORE_URL:
      'https://itunes.apple.com/us/app/sling-stay-in-sync-your-team/id922995624?mt=8',
    API_ENDPOINT: config.API_END_POINT,
    CLOUDINARY_BASE_URL: config.CLOUDINARY_BASE_URL,
    FEATURE_FLAGS: {
      ARTICLE_SEARCH_BY_PAGE: config.ARTICLE_SEARCH_BY_PAGE_ENABLED,
      ARTICLE_SEARCH: config.ARTICLE_SEARCH_ENABLED,
      AUTOMATED_BREAKS_ATTESTATIONS: config.AUTOMATED_BREAKS_ATTESTATIONS_ENABLED,
      AUTOMATED_BREAKS_PREMIUM_PAY: config.AUTOMATED_BREAKS_PREMIUM_PAY_ENABLED,
      AUTOMATED_BREAKS: config.AUTOMATED_BREAKS_ENABLED,
      CHILI_PIPER_RELEASE_DATE: config.CHILI_PIPER_RELEASE_DATE,
      CONSECUTIVE_WORK_DAYS_LIMIT_ENABLED: config.CONSECUTIVE_WORK_DAYS_LIMIT_ENABLED,
      DISABLING_SCHEDULE_AUTOSYNC: config.DISABLING_SCHEDULE_AUTOSYNC_ENABLED,
      FREE_USER_LIMIT_ENABLED: config.FREE_USER_LIMIT_ENABLED,
      GROUPED_EMAIL_NOTIFICATIONS_ENABLED: config.GROUPED_EMAIL_NOTIFICATIONS_ENABLED,
      I18N: config.I18N_ENABLED,
      ICAL_RELEASE_DATE: config.ICAL_RELEASE_DATE,
      ONBOARDING_CHECKLIST_ENABLE_DEFINE_WAGES: config.ONBOARDING_CHECKLIST_ENABLE_DEFINE_WAGES,
      ONBOARDINNG_SELECT_POS_ENABLED: config.ONBOARDINNG_SELECT_POS_ENABLED,
      PAUSE_SUBSCRIPTION_MENU_ITEM: config.PAUSE_SUBSCRIPTION_MENU_ITEM_ENABLED,
      SCHEDULE_INTERVALS_IN_SETTINGS: config.SCHEDULE_INTERVALS_IN_SETTINGS_ENABLED,
      SHIFT_ACCEPTANCE: config.SHIFT_ACCEPTANCE_ENABLED,
      SHIFT_TASK_ATTACHMENTS_ENABLED: config.SHIFT_TASK_ATTACHMENTS_ENABLED,
      TIMESHEET_CONSENT_FLOW_ENABLED: config.TIMESHEET_CONSENT_FLOW_ENABLED,
      SCHEDULED_SHIFT_IMPORT: config.SCHEDULED_SHIFT_IMPORT,
    },
    GIPHY_API_KEY: config.GIPHY_API_KEY,
    INTERCOM_APP_ID: config.INTERCOM_APP_ID,
    KIOSK_APP_URL: config.SLING_KIOSK_URL,
    PRIVACY_POLICY_URL: config.PRIVACY_POLICY_URL,
    PLAY_STORE_URL: 'https://play.google.com/store/apps/details?id=com.gangverk.sling',
    REFERRAL_PROGRAM_CODES: config.REFERRAL_PROGRAM_CODES,
    SHIFT4_REFERRAL_PROGRAM_CODE: config.SHIFT4_REFERRAL_PROGRAM_CODE,
    SLING_INTEGRATIONS_URL: config.SLING_INTEGRATIONS_URL,
    SOCKET_URL: config.WEBSOCKETS_END_POINT,
    TERMS_OF_SERVICE_URL: config.TERMS_OF_SERVICE_URL,
    TOAST_LEARN_MORE_URL: config.TOAST_LEARN_MORE_URL,
    STRIPE_PUBLIC_KEY: config.STRIPE_PUBLIC_KEY,
    SENTRY_DSN: config.SENTRY_DSN,
  });
};

export default getConfig;
